import { LegalPage } from "./LegalPage";
import { Placeholder } from "./Placeholder";

/**
 * Privacy Policy — the single source for the /privacy page.
 *
 * Every <Placeholder> lists the facts that section must cover. Replace it
 * with the approved legal text (from the owner or their lawyer) and set
 * `lastUpdated` once the wording is final.
 */
export function PrivacyPage() {
  return (
    <LegalPage title="Privacy Policy" lastUpdated="">
      <Placeholder>
        <p>
          This Privacy Policy is a draft outline. The final text must be
          supplied by Haven's owner or legal counsel before launch.
        </p>
      </Placeholder>

      <h2>Who we are</h2>
      <Placeholder>
        <p>The legal entity responsible for the data (data controller), and how to contact it about privacy.</p>
      </Placeholder>

      <h2>Information we collect</h2>
      <Placeholder>
        <ul>
          <li>Account data: name, email address, organization membership.</li>
          <li>Documents users upload, and metadata Haven derives from them (filenames, tags).</li>
          <li>Usage and audit data: page views, sign-in/sign-out events, IP address, and logs.</li>
          <li>Billing data handled by Stripe (Haven does not store card numbers).</li>
        </ul>
      </Placeholder>

      <h2>How documents are processed by AI providers</h2>
      <Placeholder>
        <ul>
          <li>
            Uploaded documents (or content extracted from them) are sent to
            third-party AI providers — Anthropic, OpenAI, and/or Google
            Gemini — to generate filenames and tags.
          </li>
          <li>Which provider is used, and whether the organization can choose or disable it.</li>
          <li>Whether those providers retain the data or use it for training, under their API terms.</li>
          <li>Where those providers process data (countries/regions).</li>
        </ul>
      </Placeholder>

      <h2>Payments</h2>
      <Placeholder>
        <p>Payments are processed by Stripe; what Stripe receives, and a link to Stripe's privacy policy.</p>
      </Placeholder>

      <h2>Sign-in</h2>
      <Placeholder>
        <p>Authentication is handled by Auth0 (Okta); what Auth0 receives (email, login events, social-login profile data), and a link to its privacy policy.</p>
      </Placeholder>

      <h2>Hosting and data location</h2>
      <Placeholder>
        <p>Haven is hosted on DigitalOcean; the data-center region where documents and databases are stored, and any cross-border transfer mechanisms.</p>
      </Placeholder>

      <h2>Retention and deletion</h2>
      <Placeholder>
        <ul>
          <li>How long documents, account data, logs, and backups are kept.</li>
          <li>How a user or organization deletes documents or their account, and how long until data is purged (including backups).</li>
          <li>What happens to data when a subscription ends.</li>
        </ul>
      </Placeholder>

      <h2>Sharing</h2>
      <Placeholder>
        <p>The full list of subprocessors (AI providers, Stripe, Auth0, DigitalOcean, email delivery, monitoring), and that data is not sold.</p>
      </Placeholder>

      <h2>Cookies and local storage</h2>
      <Placeholder>
        <p>What the app stores in the browser (session/auth tokens, preferences) and any analytics.</p>
      </Placeholder>

      <h2>Your rights</h2>
      <Placeholder>
        <p>Access, correction, export, and deletion requests; applicable laws (e.g. GDPR, CCPA); and how to submit a request.</p>
      </Placeholder>

      <h2>Security</h2>
      <Placeholder>
        <p>A summary of safeguards (encryption in transit/at rest, access controls, tenant isolation).</p>
      </Placeholder>

      <h2>Changes and contact</h2>
      <Placeholder>
        <p>How users are notified of policy changes, and a privacy contact email.</p>
      </Placeholder>
    </LegalPage>
  );
}
